/** Credits pill — hidden on partner dashboard (UI only). */
export default function CreditsBalance() {
  return null;
}
